import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService, AuthenticationTokenStorageService } from '../../services';

@Component({
  selector: 'app-login-component',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LogInComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({
    userName: new FormControl('', {
      validators: Validators.required,
    }),
    passWord: new FormControl('', {
      validators: Validators.required,
    }),
  });

  errorState = false;
  errorMessage = 'username or password is not valid!';

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly authenticationTokenStorageService: AuthenticationTokenStorageService
  ) {}

  ngOnInit(): void {
    this.authenticationTokenStorageService.clean();
  }

  ngOnSubmit = (): void => {
    const { userName, passWord } = this.loginForm.value;
    this.authService.login(userName, passWord).subscribe(
      (userData) => {
        this.authenticationTokenStorageService.save(userData);
        this.router.navigateByUrl('/home');
      },
      (e) => {
        this.errorState = true;
        if (e.status !== 401) {
          this.errorMessage = e.customErrorMessage;
        }
      }
    );
  };
}
